import utils from '@/plugins/TravellerUtils'

const realtime = {
  namespaced: true,
  state: {
    vehicles: {
      list: [],
      promise: null,
    },
    drivingCycles: {
      list: [],
    },
    BSDepartures: {
      list: [],
    },
    organisationVehicleFeatures: {
      list: [],
    },
    organizationVehicleFeatures: [],
    vehicle: null,
    blocksReport: {
      list: [],
    },
    tripsReport: {
      list: [],
    },
  },
  mutations: {
    updateVehicles(state, newList) {
      state.vehicles.list = newList
    },
    updateDrivingCycles(state, newList) {
      state.drivingCycles.list = newList
    },
    updateBSDepartures(state, newList) {
      state.BSDepartures.list = newList
    },
    setVehicleData(state, newItem) {
      state.vehicle = newItem
    },
    setOrganisationVehicleFeatures(state, newList) {
      state.organisationVehicleFeatures.list = newList
    },
    setOrganizationVehicleFeatures(state, newList) {
      state.organizationVehicleFeatures = newList
    },
    setOrganizationName(state, organizationName) {
      state.organizationName = organizationName
    },
    updateBlocksReportList(state, newList) {
      state.blocksReport.list = newList
    },
    updateTripsReportList(state, newList) {
      state.tripsReport.list = newList
    },
    setGetVehiclesPromise(state, prom) {
      state.vehicles.promise = prom
    },
  },
  actions: {
    getVehicles(context) {
      return new Promise((resolve, reject) => {
        if (context.state.vehicles.promise != null) {
          context.state.vehicles.promise.then(() => {
            resolve(context.state.vehicles.list)
          })
          return
        }
        let prom = this._vm.$traveller_http
          .get('/traveller/restui/realtime/getVehicles')
          .then(function (response) {
            if (utils.checkResponseIsArray(response)) {
              context.commit('updateVehicles', response.data)
              context.commit('setGetVehiclesPromise', null)
              resolve(context.state.vehicles.list)
            } else {
              context.commit('setGetVehiclesPromise', null)
              reject('Error getting vehicle data')
            }
          })
        prom.catch((error) => {
          context.commit('setGetVehiclesPromise', null)
          reject(error)
        })
        context.commit('setGetVehiclesPromise', prom)
      })
    },
    getOrganisationVehicleFeatures(context, organisation) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getOrganisationVehicleFeatures', {
            params: { organisation: organisation },
          })
          .then((response) => {
            context.commit('setOrganisationVehicleFeatures', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getOrganizationVehicleFeatures(context, organization) {
      // when organization is null or undefined -> all features for all organization will be fetched')

      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getOrganizationVehicleFeatures', {
            params: { organization: organization },
          })
          .then((response) => {
            context.commit('setOrganizationVehicleFeatures', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getOrganizationName(context, organizationId) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getOrganizationName', {
            params: { organizationId: organizationId },
          })
          .then((response) => {
            context.commit('setOrganizationName', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    emptyOrganizationVehicleFeatures(context) {
      context.commit('setOrganizationVehicleFeatures', [])
    },
    fetchOrganizationVehicleFeatures(_context, organization) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getOrganizationVehicleFeatures', {
            params: { organization: organization },
          })
          .then((response) => {
            resolve(response.data || [])
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateVehicle(context, newVehicle) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/realtime/saveVehicle', newVehicle)
          .then((response) => {
            if (response.status == 200) context.dispatch('getVehicles')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteVehicle(context, vehicleId) {
      return new Promise((resolve, reject) => {
        let config = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }
        this._vm.$traveller_http
          .post('/traveller/restui/realtime/deleteVehicle', vehicleId, config)
          .then((response) => {
            if (response.status == 200) context.dispatch('getVehicles')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDrivingCycles(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getDrivingCycles')
          .then(function (response) {
            if (utils.checkResponseIsArray(response)) {
              context.commit('updateDrivingCycles', response.data)
              resolve(response)
            } else {
              reject('Error getting DrivingCycles')
            }
          })
          .catch(() => {
            reject('Error getting DrivingCycles')
          })
      })
    },
    getBSDepartures(context, blocksequence) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/realtime/getBSDepartures', {
            params: { blocksequence: blocksequence },
          })
          .then(function (response) {
            context.commit('updateBSDepartures', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getVehicleList(context) {
      this._vm.$traveller_http
        .get('/traveller/restui/realtime/getVehicles')
        .then((response) => {
          context.commit('updateVehicles', response.data)
        })
    },
    getBlocksReport(context, timeRange) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/blocks', { params: timeRange })
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateBlocksReportList', response.data)
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getBlocksReportXLS(_context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/blocksXLS', {
            params: data,
            responseType: 'blob',
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: 'application/xlsx' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'blocks_report.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getBlocks(_context, timeRange) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/getBlocks', { params: timeRange })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getTrips(_context, timeRange) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/getTrips', { params: timeRange })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getTripsReport(context, timeRange) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/trips', { params: timeRange })
          .then((response) => {
            if (response.status == 200) {
              context.commit('updateTripsReportList', response.data)
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getTripsReportXLS(_context, data) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .get('/traveller/restui/report/tripsXLS', {
            params: data,
            responseType: 'blob',
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: 'application/xlsx' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'trips_report.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    setVehicle(context, blocksequence) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http
          .post('/traveller/restui/realtime/setVehicle', blocksequence)
          .then((response) => {
            if (response.status == 200) {
              context.dispatch('getDrivingCycles')
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {
    getVehicleTypes(state) {
      if (state.vehicles.list == undefined) {
        return []
      }
      let lista = state.vehicles.list
      let typeSet = new Set()
      lista.forEach((v) => {
        try {
          if (v.features.VEHICLE_TYPE.length > 0) {
            typeSet.add(v.features.VEHICLE_TYPE)
          }
        } catch (err) {
          /*empty*/
        }
      })
      return Array.from(typeSet)
    },
    getVehicleBySipId: (state) => (sipId) => {
      let vehicleList = state.vehicles.list
      if (vehicleList == undefined) {
        state.context.dispatch('getVehicles')
      }
      if (vehicleList == undefined) {
        return {}
      }
      return vehicleList.find((vehicle) => {
        if (vehicle.features != undefined) {
          if (vehicle.features == undefined) return false
          return vehicle.features['SIP_CLIENT_ID'] === sipId
        }
      })
    },
    getVehicleByLabel: (state) => (vehicleLabel) => {
      return state.vehicles.list.find((vehicle) => {
        return vehicle.vehicleLabel == vehicleLabel
      })
    },
    getVehicleById: (state) => (vehicleId) => {
      return state.vehicles.list.find((vehicle) => {
        return vehicle.vehicleId == vehicleId
      })
    },
  },
}

export default realtime
